import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import routes from './routes'
import store from "@/store"
let router = new Router({
  // mode: 'history',
  routes,
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
router.beforeEach((to, from, next) => {

  next()
})
export default router
